<template>
  <div class="audioControls" :style="cssProps">
    <div v-show="audioFile && !recordAudioState" ref="audio" class="audio audioStyle" >
      <audio controls="controls" class="audioStyle"></audio>
    </div>
    <div style="margin-top: 12px">
      <ui-button
        v-if="!recordAudioState && !audioFile" variant="primary"
        @click="permissionStatus === 'denied' || audioIsPlaying === false ? recordAudio() : false"
        class="flex-1 relative">
        <v-remixicon name="riRecordCircleFill" class="mr-2 -ml-1" />
        Bấm để ghi âm
      </ui-button>

      <ui-button
        v-if="recordAudioState" variant="danger"
        @click="stopRecordAudio"
        class="flex-1 relative">
        <v-remixicon name="riPauseLine" class="mr-2 -ml-1" />
        Dừng
      </ui-button>
    </div>
    <div v-show="recordAudioState && timer" style="margin-top: 16px">
      <span class="audioTimer" ref="audioTimer"></span>
    </div>
    <div v-show="audioFile && !recordAudioState" style="margin-top: 12px; margin-bottom: 12px">
      <ui-button variant="danger"
        :disabled="audioIsPlaying"
        @click="deleteAudioFile"
        class="flex-1 relative">
        <v-remixicon name="riDeleteBin7Line" class="mr-2 -ml-1" />
        Xoá ghi âm này
      </ui-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AudioRecorder',
  props: {
    timer: {
      type: Boolean,
      default: true,
    },
    timerColor: {
      type: String,
      default: '#000',
    },
    timerFontSize: {
      type: Number,
      default: 1,
    },
    timerBackground: {
      type: String,
      default: '#ccc',
    },
    audioWidth: {
      type: Number,
      default: 200,
    },
    removeAudioCallback: {
      type: Function,
      default: () => {}
    }
  },
  mounted() {
    this.checkPermission();
  },
  data() {
    return {
      permissionStatus: null,
      recorder: null,
      audioIsPlaying: false,
      audioFile: null,
      audioType: 'audio/x-wav',
      audioFileName: 'audio.wav',
      uploadedAudioFile: null,
      recordAudioState: false,
      initialTime: Date.now(),
    };
  },
  methods: {
    async checkPermission() {
      const status = await navigator.permissions.query(
        { name: 'microphone' },
      );
      this.permissionStatus = status.state;
    },
    clearAudio() {
      const TIMER = this.$refs.audioTimer;
      this.initialTime = Date.now();
      TIMER.innerText = '';
    },
    checkAudioTime() {
      const TIMER = this.$refs.audioTimer;
      const timeDifference = Date.now() - this.initialTime;
      const formatted = this.convertAudioTime(timeDifference);
      TIMER.innerHTML = `${formatted}`;
    },
    convertAudioTime(miliseconds) {
      const totalSeconds = Math.floor(miliseconds / 1000);
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds - minutes * 60;
      const sec = seconds < 10 ? `0${seconds}` : seconds;
      return `${minutes}:${sec}`;
    },
    recordAudio() {
      this.clearAudio();
      try {
        const device = navigator.mediaDevices.getUserMedia({ audio: true });
        const items = [];
        device.then((stream) => {
          this.recorder = new MediaRecorder(stream);
          this.recorder.ondataavailable = (e) => {
            items.push(e.data);
            if (this.recorder.state === 'inactive') {
              const blob = new Blob(items, { type: this.audioType });
              this.audioFile = URL.createObjectURL(blob);
              this.uploadedAudioFile = blob;
              const { audio } = this.$refs;
              audio.innerHTML = '';
              const mainaudio = document.createElement('audio');
              mainaudio.setAttribute('controls', 'controls');
              mainaudio.setAttribute('style', `width: ${this.audioWidth}px`);
              audio.appendChild(mainaudio);
              mainaudio.innerHTML = `<source src="${this.audioFile}" type="${this.audioType}" />`;
              mainaudio.onplay = () => {
                this.audioIsPlaying = true;
              };
              mainaudio.onpause = () => {
                this.audioIsPlaying = false;
              };
              mainaudio.onended = () => {
                this.audioIsPlaying = false;
              };
            }
          };
          this.recordAudioState = true;
          this.audioInterval = setInterval(this.checkAudioTime, 500);
          this.recorder.start();
        }).catch((err) => {
          // eslint-disable-next-line no-alert
          alert(err);
          // eslint-disable-next-line no-console
          console.log(err);
        });
      } catch (err) {
        // eslint-disable-next-line no-alert
        alert(`Audio error:  ${err}`);
        // eslint-disable-next-line no-console
        console.error('Audio error: ', err);
      }
    },
    stopRecordAudio() {
      clearInterval(this.audioInterval);
      this.recorder.stop();
      this.recordAudioState = false;
    },
    deleteAudioFile() {
      if (this.recordAudioState === false) {
        this.audioFile = null;
        this.uploadedAudioFile = null;
        this.removeAudioCallback()
      }
    },
  },
  computed: {
    cssProps() {
      return {
        '--font-size': `${this.timerFontSize}em`,
        '--font-color': this.timerColor,
        '--timer-background': this.timerBackground,
        '--audio-width': `${this.audioWidth}px`,
      };
    },
  },
  watch: {
    uploadedAudioFile(value) {
      this.$emit('audioFile', value);
    },
  },
};
</script>

<style scoped>
.audioControls {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.audioStyle {
  width: var(--audio-width);
}

.ar-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  padding: 5px;
}

audio {
  max-height: 100%;
  max-width: 100%;
  margin: auto;
  object-fit: contain;
}

.audio {
  margin: 0 5px;
}
.recorder-start {
  background: green;
}
.recorder-start-error {
  background: gray;
}

.recorder-stop {
  background: red;
  box-shadow: 0 0 0 0 rgba(255, 82, 82, 1);
  animation: pulse 1500ms infinite;
}

@keyframes pulse {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 82, 82, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(255, 255, 255, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
  }
}

.audioTimer {
  background: var(--timer-background);
  padding: 5px 20px;
  color: var(--font-color);
  border-radius: 5%;
  font-size: var(--font-size);
  font-weight: bold;
  margin: 0 0 0 5px;
}

.deleteAudio {
  background-color: darkred;
  color: #fff;
  padding: 5px;
  border-radius: 50px;
  width: 30px;
  height: 30px;
  border: none;
  font-weight: bold;
}

.deleteAudio:disabled {
  background-color: palevioletred;
}

.pointer {
  cursor: pointer;
}
</style>
